import { FinancialConfig } from '@futrli-sdk/predict';

import { PeriodType } from '../../../../core/constants';
import { getPreviousDaysInMonth } from '../../../../utils/dates';
import { FY_PREFIX } from '../../reports/data-grid/format-rows';
import { TotalRow } from '../../reports/data-grid/types';

export const getColumnsWithFYInfo = (columns: string[], financialConfig: FinancialConfig) => {
  return columns.reduce<string[]>((columnsWithFY, column) => {
    columnsWithFY.push(column);

    const [columnYear, columnMonth] = column.split('-');
    if (Number(columnMonth) === financialConfig.year_end.month) {
      columnsWithFY.push(`${FY_PREFIX} ${columnYear}`);
    }

    return columnsWithFY;
  }, []);
};

export const getColumnsForPredictionOrCashImpact = (
  reportColumns: string[],
  isPayment: boolean,
  periodType: PeriodType,
  financialConfig?: FinancialConfig
) => {
  if (!isPayment && financialConfig && periodType === 'MONTHLY') {
    return getColumnsWithFYInfo(reportColumns, financialConfig);
  }
  return reportColumns;
};

export const adjustForPastDates = (row: TotalRow) => {
  if (!row.dailyColumns || !row.dailyData) {
    return row;
  }

  const previousDays = getPreviousDaysInMonth(row.dailyColumns[0]);
  return {
    ...row,
    dailyColumns: [...previousDays, ...row.dailyColumns],
    dailyData: [...previousDays.map(() => null), ...row.dailyData]
  } as TotalRow;
};
